//format  -  weight 10  -  valor

import { valorPallgrow } from "./eliminarEs"

export function percentage(formatGr, weight, value) {
    const total = (Math.round(((((weight / 10) * valorPallgrow(value)) / formatGr) * 100) * 10) / 10)
    // const total = ((((((weig/10)*valorPallgrow(fru))/form)*100) * 10) / 10).toFixed(2)
    if (total === Infinity) {
        return "--"
    } else if (total.toString() === "0.00") {
        return `0%`
    } else if (total) {
        return `${total}%`
    } else {
        return "0%"
    }
}

export function percentageNum(formatGr = 0, weight = 0, value = []) {

    const total = (Math.round(((((weight / 10) * valorPallgrow(value)) / formatGr) * 100) * 10) / 10)

    if (total === Infinity) {
        return 0
    } else if (total.toString() === "0.00") {
        return 0
    } else if (total) {
        return total
    } else {
        return 0
    }
}


// Porcentage de defecto FINAL 2026
export function percentageNew(formatGr = 0, weight = 0, value = 0, samples = 1) {

    // toFixed 1
    // const total = Math.round(((weight / 10) * (value / samples) / formatGr) * 1000) / 10
    const total = (((weight / 10) * (value / samples) / formatGr) * 100).toFixed(2)
    // Math.round(((55 / 10) * (1 / 10) / 125) * 100
    // 5,5 * 0,1 / 125
    
    // toFixed 2
    // const total = Math.round(((weight) * (value / samples) / formatGr) * 1000) / 100

    if (total === Infinity) {
        return 0
    } else if (total.toString() === "0.00") {
        return 0
    } else if (total) {
        return total
    } else {
        return 0
    }
}